module.exports = __webpack_public_path__ + "img/onepack-inactive.8dddc984.svg";